import CryptoJS from "crypto-js";

const SECRET_KEY = "devgenius_secret_key"; // Change this to a secure key in production

export function encryptId(id) {
  return CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
}

export function decryptId(ciphertext) {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return null;
  }
}
